import {IdCodeNameModel} from "common-shared";
import {Type} from "class-transformer";
import {MasterOperationModel} from "./master-operation.model";
import {PropertyMappingModel} from "../../properties/models/property-mapping.model";
import {ExpressionModel} from "../../common/expression.model";
import {SpecLineModel} from "../../properties/models/spec-line.model";

export class ProcessSelectorModel extends IdCodeNameModel {
  @Type(() => PropertyMappingModel)
  Mappings: PropertyMappingModel[] = [];
  ValidCondition: ExpressionModel = new ExpressionModel();
  Sequence?: number;
  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];
  SourceCode?: string;

  constructor(init?: Partial<ProcessSelectorModel>) {
    super();
    Object.assign(this, init);
  }

  isValid(): boolean {
    return this.Specs.every(spec => spec.isValid());
  }

  public static createValid(): ProcessSelectorModel {
    return new ProcessSelectorModel({Id: null, Code: ' - ', ValidCondition: new ExpressionModel({Formula: 'True'})});
  }
}

export class ProcessSelectorWithOperationsModel {
  @Type(() => ProcessSelectorModel)
  ProcessSelector: ProcessSelectorModel;
  @Type(() => MasterOperationModel)
  MasterOperations: MasterOperationModel[] = [];

  constructor(init?: Partial<ProcessSelectorWithOperationsModel>) {
    Object.assign(this, init);
  }

  public static convertTo(ps: ProcessSelectorModel, masterOperations: MasterOperationModel[]): ProcessSelectorWithOperationsModel {
    return new ProcessSelectorWithOperationsModel({
      ProcessSelector: ps,
      MasterOperations: masterOperations.filter(mo => mo.ProcessSelectorId === ps.Id)
    });
  }
}


